import { createContext, useContext } from 'react';
const FormatterContext = /*#__PURE__*/createContext(undefined);

/**
 * Provider for a Formatter across the whole application. This can make it easier to configure one Formatter
 * at the root of your application and get access to it anywhere.
 */
export const FormatterProvider = FormatterContext.Provider;

/**
 * Retrieves the Formatter configured in FormatterProvider.
 * @returns A Formatter
 */
export const useFormatter = () => {
  return useContext(FormatterContext);
};
//# sourceMappingURL=FormatterContext.js.map